import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Layout } from './Home';

const prettify = (path) =>
  path
    .split('/')
    .filter(Boolean)
    .map((s) => s.replace(/-/g, ' '))
    .map((s) => s.replace(/\b\w/g, (c) => c.toUpperCase()))
    .join(' – ');

const Placeholder = () => {
  const location = useLocation();
  const title = prettify(location.pathname) || 'Page';

  return (
    <Layout>
      <section className="bg-[#e2ede6] py-20 lg:py-28">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <span className="text-xs font-semibold tracking-[0.25em] text-[#0f5c3d] uppercase">
            Emerald Corporates
          </span>
          <h1
            className="mt-4 text-5xl lg:text-6xl text-[#0b1a2e]"
            style={{ fontFamily: 'Cormorant Garamond, serif', fontWeight: 500 }}
          >
            {title}
          </h1>
          <p className="mt-6 text-[#0b1a2e]/70 leading-relaxed max-w-2xl mx-auto">
            This section is part of the Emerald Corporates experience. Detailed
            content for {title} will be curated by our editorial team. In the
            meantime, explore other verticals of our global conglomerate.
          </p>
          <Link
            to="/"
            className="mt-10 inline-flex items-center gap-3 px-6 py-3.5 rounded-full border border-[#0b1a2e]/70 text-[#0b1a2e] hover:bg-[#0b1a2e] hover:text-white transition-all duration-300"
          >
            <ArrowLeft className="w-4 h-4" />
            <span className="text-sm font-medium tracking-wide">
              Back to Home
            </span>
          </Link>
        </div>
      </section>
    </Layout>
  );
};

export default Placeholder;
